import './style.css'
import Button from '../atoms/Buttons'
import { useFormContext } from 'react-hook-form'
import bg_image from '../../assets/icons/cactus_background.svg'

export const PreviewHeroBanner = ({ imageUrl, videoUrl, logoUrl }) => {
  const methods = useFormContext();
  console.log("getValues", methods?.getValues("title"))

  const handleRedirect = url => {
    const formattedUrl = url?.startsWith('http') ? url : `http://${url}`
    window.open(formattedUrl, '_blank')
  }

  return (
    <div className="h-[212.131px] sm:h-[422px] lg:h-[701px] w-full relative">
      {imageUrl ? (
        <img
          src={imageUrl || bg_image}
          alt="bg_image"
          className="h-[212.131px] sm:h-[422px] lg:h-[701px] w-full object-cover"
        />
      ) : (
        <video
          className="w-full h-[212.131px] sm:h-[422px] lg:h-[701px] object-cover"
          src={videoUrl}
          autoPlay
          loop
          muted
        />
      )}

      <div className="absolute top-[50%] space-y-[.5rem]  text-center left-[50%] transform -translate-x-1/2 -translate-y-1/2">
        <img src={logoUrl} alt="logo" className="w-auto h-[100px] object-cover" />
        <h1 id="title" className='text-[24px] sm:text-[38px] md:text-[46px] lg:text-[64px]'>{methods?.watch('title') || 'MADE IN THE USA'}</h1>
        <p className="preview_description text-[10px] sm:text-[14px] leading-[12px] sm:leading-[24px]">
          {methods?.watch('description') ||
            'Every saddle is hand-crafted in Greenville, TX. We are the Choice of Champions.'}
        </p>
        <Button
          onClick={() => handleRedirect(methods?.watch('url'))}
          className="preview_btn mx-auto cursor-pointer"
        >
          {methods?.watch('btnLabel') || ''}
        </Button>
      </div>
    </div>
  )
}
